import React from "react";
import { useTranslation } from "react-i18next";

function GoalSelection({ selectedGoal, onGoalSelect }) {
  const { t } = useTranslation('fastresearch');

  const goals = [
    {
      id: "get_more_customers",
      label: t('goalSelection.getMoreCustomers'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="5"/>
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <polyline points="16 11 19 8 22 11"/>
          <line x1="19" y1="8" x2="19" y2="14"/>
        </svg>
      )
    },
    {
      id: "improve_customer_satisfaction",
      label: t('goalSelection.improveCustomerSatisfaction'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      )
    },
    {
      id: "understand_target_audience",
      label: t('goalSelection.understandTargetAudience'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <circle cx="12" cy="12" r="6"/>
          <circle cx="12" cy="12" r="2"/>
        </svg>
      )
    },
    {
      id: "test_product_idea",
      label: t('goalSelection.testProductIdea'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 11l3 3L22 4"/>
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
        </svg>
      )
    },
    {
      id: "understand_competitors",
      label: t('goalSelection.understandCompetitors'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="8.5" cy="7" r="4"/>
          <polyline points="17 11 19 13 23 9"/>
        </svg>
      )
    },
    {
      id: "something_else",
      label: t('goalSelection.somethingElse'),
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="1"/>
          <circle cx="19" cy="12" r="1"/>
          <circle cx="5" cy="12" r="1"/>
        </svg>
      )
    }
  ];

  return (
    <>
      <h1 style={{
        fontSize: "clamp(2rem, 8vw, 2.75rem)",
        marginBottom: "1rem",
        fontWeight: "900",
        color: "#fff",
        letterSpacing: "-0.04em",
        lineHeight: "1",
        textAlign: "center"
      }}>
        {t('goalSelection.title')}
      </h1>

      <p style={{
        fontSize: "clamp(0.9375rem, 3vw, 1rem)",
        color: "#888",
        marginBottom: "2rem",
        lineHeight: "1.5",
        textAlign: "center"
      }}>
        {t('goalSelection.subtitle')}
      </p>

      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem"
      }}>
        {goals.map((goal) => (
          <button
            key={goal.id}
            onClick={() => onGoalSelect(goal.id)}
            style={{
              padding: "1.125rem 1.25rem",
              fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
              fontWeight: "700",
              border: selectedGoal === goal.id ? "1px solid rgba(99, 102, 241, 0.5)" : "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: "10px",
              backgroundColor: selectedGoal === goal.id ? "rgba(99, 102, 241, 0.2)" : "rgba(255, 255, 255, 0.05)",
              color: "#fff",
              cursor: "pointer",
              transition: "all 0.3s ease",
              textAlign: "left",
              letterSpacing: "0.02em",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "0.75rem"
            }}
            className="goal-button"
            onMouseEnter={(e) => {
              if (selectedGoal !== goal.id) {
                e.currentTarget.style.backgroundColor = "rgba(99, 102, 241, 0.1)";
                e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.3)";
              }
            }}
            onMouseLeave={(e) => {
              if (selectedGoal !== goal.id) {
                e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
              }
            }}
          >
            <div style={{
              color: "#a78bfa",
              transition: "color 0.3s ease",
              display: "flex",
              alignItems: "center",
              flexShrink: 0
            }}>
              {goal.icon}
            </div>
            <span>{goal.label}</span>
          </button>
        ))}
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .goal-button {
              padding-left: 14rem !important;
            }
          }
        `}
      </style>
    </>
  );
}

export default GoalSelection;
